type Props = {
	children: React.ReactNode;
};

export default function Badge({ children }: Props): JSX.Element {
	return (
		<span className="inline-flex items-center rounded-full border border-[rgb(var(--border)/0.10)] bg-[rgb(var(--surface)/0.05)] px-2.5 py-1 text-xs text-[rgb(var(--muted2))]">
			{children}
		</span>
	);
}
